var EmailValidator = require('commons-validator-js').EmailValidator;

const fontMetricsLookupMap = {}

export function validate(rules, value) {
    let validationResults = [];
    for (var ruleName in rules) {
        if(validationResults.length > 0){
            for(let i=0;i<validationResults.length;i++){
                if(!validationResults[i].isValid){
                    return validationResults;
                }
            }
        }
        let rule = rules[ruleName];
        if(ruleName === "required") handleResult(validationResults,required(rule, value))
        if(ruleName === "email") handleResult(validationResults,email(rule,value))
        if(ruleName === "creditCard") handleResult(validationResults,creditCard(rule,value))
        if(ruleName === "phone") handleResult(validationResults,phone(rule,value))
        if(ruleName === "fullName") handleResult(validationResults,fullName(rule,value))
        if(ruleName === "regex") handleResult(validationResults,regex(rule,value))
        if(ruleName === "length") handleResult(validationResults,length(rule,value == null ? null : value.trim()))
        if(ruleName === "fontMetrics") handleResult(validationResults,fontMetrics(rule,value == null ? null : value.trim()))
        if(ruleName === "passwordConfirm") handleResult(validationResults,{rule: "passwordConfirm", isValid: rule.isValid , message:"Passwords do not match"})
        if(ruleName === "numeric") handleResult(validationResults, numeric(rule, value));
        if(ruleName === "creditCardName") handleResult(validationResults, creditCardName(rule, value));
        if(ruleName === "noPOBox") handleResult(validationResults, noPOBox(rule, value));
    }
    return validationResults;

}
function handleResult(results, result){
    if(result !== null){
        results.push(result);
    }
}
function noPOBox(rule,value){
    if(typeof(value) === "undefined" || value == null || value.length == 0 ){
        return {rule: "noPOBox", isValid:true};
    }
    let upperTmp = value.toUpperCase().trim();
    if(upperTmp.startsWith("PO ") || upperTmp.includes("P.O.") || upperTmp.includes("P.O") || upperTmp.includes("POST OFFICE") || upperTmp.includes("P O ")) {
        return {rule: "noPOBox", isValid:false, message: "We cannot ship to P.O. Boxes"};
    }else{
        return {rule: "noPOBox", isValid:true};
    }
}
function creditCardName(rule, value){
    if(typeof(value) === "undefined" || value == null || value.length == 0 ){
        return {rule: "creditCardName", isValid:false, message: "Field is required"}
    }
    if(value.trim().length > 22){
        return {rule: "creditCardName", isValid:false, message: "Max length is 22 characters"}
    }
    var alphaAndAposRegex = /^[A-Za-z \'-]+$/
    if(!alphaAndAposRegex.test(value.trim())){
        return {rule: "creditCardName", isValid:false, message: "Only alpha characters allowed"}
    }
    return {rule: "creditCardName", isValid:true}

}
function required(rule, value){
    if(rule === false){
        return {rule: "required", isValid: true};
    }
    if(typeof(value) === "undefined" || value === null || (typeof(value) === "boolean" && value === false) || (typeof(value) === "string" && value.trim() === "")){
        return {rule: "required", isValid:false, message: typeof(rule.message) !== "undefined"?rule.message:"Field is required"}
    }else{
        return {rule: "required", isValid: true};
    }
}
function length(rule, value){
    if(typeof(value) === "undefined" || value === null || value === ""){
        //You should use the required rule if you want to fail if the value is not present
        return {rule: "length", isValid: true}
    }
    if(rule.max){
        if(value.length > rule.max){
            return {rule: "length",isValid:false, message: typeof(rule.maxMessage) !== "undefined"?rule.maxMessage:"Max length is "+rule.max};
        }
    }
    if(rule.min){
        if(value.length < rule.min){
            return {rule: "length",isValid:false, message: typeof(rule.minMessage) !== "undefined"?rule.minMessage:"Min length is "+rule.min};
        }
    }
    return {rule: "length", isValid: true}
}
function email(rule, value){
    var validator = new EmailValidator();
      if(!validator.isValid(value)){
        return {rule: "email",isValid:false, message: typeof(rule.message)!== "undefined"?rule.message:"Valid email is required" }
    }else{
        return {rule: "email", isValid: true};
    }
}
function numeric(rule, value){
    var reg = /^\d+$/;
    if(reg.test(value)){
        let numVal = parseFloat(value);
        if(rule.min){
            if(numVal < parseFloat(rule.min)){
                return {rule: "numeric",isValid:false,message: typeof(rule.message)!== "undefined"?rule.message: "Value must be number greater than "+rule.min}
            }
        }
        if(rule.max){
            if(numVal > parseFloat(rule.max)){
                return {rule: "numeric",isValid:false,message: typeof(rule.message)!== "undefined"?rule.message: "Value must be number less than "+rule.max}
            }
        }
        return {rule: numeric, isValid:true}
    }else{
        return {rule: "numeric",isValid:false,message: typeof(rule.message)!== "undefined"?rule.message: "Numbers only"}
    }
}
function creditCard(rule,value){
    const americanExpress = /(?:3[47][0-9]{13})/;
    const dinersClub = /(?:3(?:0[0-5]|[68][0-9])[0-9]{11})/;
    const discover = /(?:6(?:011|5[0-9]{2})(?:[0-9]{12}))/;
    const jcb = /(?:(?:2131|1800|35\\d{3})\\d{11})/;
    const maestro = /(?:(?:5[0678]\\d\\d|6304|6390|67\\d\\d)\\d{8,15})/;
    const mastercard = /(?:(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12})/;
    const visa = /(?:4[0-9]{12})(?:[0-9]{3})?/;
    if(typeof(value) === "undefined" || value == null || value.length == 0 ){
        return {rule: "creditCard", isValid:false, message: "Field is required"}
    }
    let ccNumbers = value.replace(/\D/g, '');
    if(americanExpress.test(ccNumbers) || dinersClub.test(ccNumbers) || discover.test(ccNumbers) || jcb.test(ccNumbers) || mastercard.test(ccNumbers) || visa.test(ccNumbers)){
        return {rule: "creditCard", isValid: true};
    } else {
        return {rule: "creditCard", isValid:false, message: typeof(rule.message)!== "undefined"?rule.message:"Invalid card number"}
    }
}
function phone(rule,value) {
    const validPhoneNumber = value.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/);
    return validPhoneNumber ? {rule: 'email', isValid: true} : {rule: 'email', isValid: false, message: 'Invalid phone number'};
}
function fullName(rule, value) {
    const validFullName = value.match(/^[a-zA-Z ]+[\s]+[a-zA-Z]+$/);
    return validFullName ? {rule: 'fullName', isValid: true} : {rule: 'fullName', isValid: false, message: 'Please enter your full name with a space between First and Last name'}
}
function regex(rule, value){
    let regex = new RegExp(rule.regex)
    if(!regex.test(value)){
        return {rule: "regex", isValid: false, message: typeof(rule.message)!== "undefined"?rule.message:"Invalid format"}
    }else{
        return {rule: "regex", isValid: true};
    }
}
function fontMetrics(rule,value){
    //var _maxWidthForDisc = fontMetricsLookupMap[77] * 19;
    //var _maxWidthForClip = fontMetricsLookupMap[77] * 9;
    if(typeof(value) === "undefined" || value === null){
        //You should use the required rule if you want to fail if the value is not present
        return {rule: "fontMetrics", isValid: true}
    }
    if(typeof(fontMetricsLookupMap[32]) === "undefined") {
        populateFontMetricsLookupMap()
    }
    let totalSize = 0;
    for(let i=0;i<(""+value).length;i++){
        let charSize = fontMetricsLookupMap[value.charCodeAt(i)]
        if(typeof(charSize) === "undefined" || charSize == null){
            return {rule: "fontMetrics",isValid:false,message: "'" + value.charAt(i)+"' is not valid for print"}
        }
        totalSize += charSize;
        if(totalSize > (fontMetricsLookupMap['M'.charCodeAt(0)] * rule.max)){
            return {rule: "fontMetrics",isValid:false,message: "Print size exceeded"}
        }
    }
    return {rule: "fontMetrics", isValid:true}
}
function populateFontMetricsLookupMap(){
    fontMetricsLookupMap[32] = 9.54; // [space]
    fontMetricsLookupMap[97] = 17.25; // a
    fontMetricsLookupMap[98] = 20.19; // b
    fontMetricsLookupMap[99] = 16.00; // c
    fontMetricsLookupMap[100] = 20.19; // d
    fontMetricsLookupMap[101] = 18.43; // e
    fontMetricsLookupMap[102] = 11.30; // f
    fontMetricsLookupMap[103] = 20.19; // g
    fontMetricsLookupMap[104] = 18.43; // h
    fontMetricsLookupMap[105] = 8.32; // i
    fontMetricsLookupMap[106] = 8.32; // j
    fontMetricsLookupMap[107] = 17.25; // k
    fontMetricsLookupMap[108] = 8.32; // l
    fontMetricsLookupMap[109] = 27.90; // m
    fontMetricsLookupMap[110] = 18.43; // n
    fontMetricsLookupMap[111] = 19.65; // o
    fontMetricsLookupMap[112] = 20.19; // p
    fontMetricsLookupMap[113] = 20.19; // q
    fontMetricsLookupMap[114] = 12.48; // r
    fontMetricsLookupMap[115] = 14.85; // s
    fontMetricsLookupMap[116] = 12.48; // t
    fontMetricsLookupMap[117] = 18.43; // u
    fontMetricsLookupMap[118] = 16.64; // v
    fontMetricsLookupMap[119] = 24.93; // w
    fontMetricsLookupMap[120] = 17.25; // x
    fontMetricsLookupMap[121] = 16.64; // y
    fontMetricsLookupMap[122] = 15.46; // z

    fontMetricsLookupMap[65] = 23.17; // A
    fontMetricsLookupMap[66] = 20.80; // B
    fontMetricsLookupMap[67] = 23.17; // C
    fontMetricsLookupMap[68] = 24.35; // D
    fontMetricsLookupMap[69] = 20.19; // E
    fontMetricsLookupMap[70] = 19.01; // F
    fontMetricsLookupMap[71] = 25.54; // G
    fontMetricsLookupMap[72] = 24.35; // H
    fontMetricsLookupMap[73] = 9.54; // I
    fontMetricsLookupMap[74] = 16.06; // J
    fontMetricsLookupMap[75] = 21.38; // K
    fontMetricsLookupMap[76] = 17.25; // L
    fontMetricsLookupMap[77] = 29.63; // M
    fontMetricsLookupMap[78] = 26.11; // N
    fontMetricsLookupMap[79] = 27.26; // O
    fontMetricsLookupMap[80] = 19.62; // P
    fontMetricsLookupMap[81] = 27.26; // Q
    fontMetricsLookupMap[82] = 20.19; // R
    fontMetricsLookupMap[83] = 18.43; // S
    fontMetricsLookupMap[84] = 19.01; // T
    fontMetricsLookupMap[85] = 23.17; // U
    fontMetricsLookupMap[86] = 20.84; // V
    fontMetricsLookupMap[87] = 31.42; // W
    fontMetricsLookupMap[88] = 21.38; // X
    fontMetricsLookupMap[89] = 20.22; // Y
    fontMetricsLookupMap[90] = 19.62; // Z

    fontMetricsLookupMap[49] = 18.43; // 1
    fontMetricsLookupMap[50] = 18.43; // 2
    fontMetricsLookupMap[51] = 18.43; // 3
    fontMetricsLookupMap[52] = 18.43; // 4
    fontMetricsLookupMap[53] = 18.43; // 5
    fontMetricsLookupMap[54] = 18.43; // 6
    fontMetricsLookupMap[55] = 18.43; // 7
    fontMetricsLookupMap[56] = 18.43; // 8
    fontMetricsLookupMap[57] = 18.43; // 9
    fontMetricsLookupMap[48] = 18.43; // 0


    fontMetricsLookupMap[96] = 8.32; // `

    fontMetricsLookupMap[61] = 21.95; // =
    fontMetricsLookupMap[126] = 21.95; // ~
    fontMetricsLookupMap[33] = 9.54; // !
    fontMetricsLookupMap[64] = 26.24; // @
    fontMetricsLookupMap[35] = 18.43; // #
    fontMetricsLookupMap[36] = 18.43; // $
    fontMetricsLookupMap[37] = 28.00; // %
    fontMetricsLookupMap[94] = 21.95; // ^
    fontMetricsLookupMap[38] = 23.74; // &
    fontMetricsLookupMap[40] = 9.54; // (
    fontMetricsLookupMap[41] = 9.54; // )
    fontMetricsLookupMap[42] = 15.49; // *
    fontMetricsLookupMap[43] = 21.95; // +
    fontMetricsLookupMap[45] = 10.75; // -
    fontMetricsLookupMap[95] = 16.64; // _
    fontMetricsLookupMap[91] = 9.54; // [
    fontMetricsLookupMap[93] = 9.54; // ]
    fontMetricsLookupMap[92] = 13.09; // \
    fontMetricsLookupMap[123] = 11.30; // {
    fontMetricsLookupMap[125] = 11.30; // }
    fontMetricsLookupMap[124] = 7.74; // |
    fontMetricsLookupMap[59] = 9.54; // ;
    fontMetricsLookupMap[39] = 9.54; // '
    fontMetricsLookupMap[58] = 9.54; // :
    fontMetricsLookupMap[34] = 17.25; // "
    fontMetricsLookupMap[44] = 9.54; // ,
    fontMetricsLookupMap[46] = 9.54; // .
    fontMetricsLookupMap[47] = 13.09; // /
    fontMetricsLookupMap[60] = 21.95; // <
    fontMetricsLookupMap[62] = 21.95; // >
    fontMetricsLookupMap[63] = 16.64; // ?
}



// WEBPACK FOOTER //
// ./src/common/components/forms/validation.js